<template>
  <div>
    <div v-show="conShow">
      <div>
        <headMenu @showApply="showApply"></headMenu>
      </div>
      <div>
        <div>
          <img style="width: 100%" src="../assets/news/xw.png" alt="">
        </div>
      </div>
    </div>
    <applyDetails ref="apply" @returnPage="returnPage"></applyDetails>
  </div>
</template>

<script>
import headMenu from "@/head/headMenu.vue";
import applyDetails from "@/head/components/applyDetails.vue";

export default {
  name: "news",
  components: {applyDetails, headMenu},
  data() {
    return {
      conShow: true
    }
  },
  mounted() {
    this.conShow = true
    this.axios({
      url: 'http://test.gocheck.cn/newsAction/searchNews.do',//请求地址
      method:'post',//请求方法
      responseType: 'json',//返回值类型
      async: false,
      params: {
        NEWSTYPE: 9,
        newsPage: 1
      }
    }).then(res => {
      console.log(res)//请求成功
    }).catch(error => {
      console.log(error);//请求失败
    })
  },
  methods: {
    showApply() {
      this.conShow = false
      this.$refs.apply.init()
    },
    returnPage() {
      this.conShow = true
    },
  }
}
</script>

<style scoped>

</style>